const competitionStatus = {
    0: {name: '진행예정'},
    1: {name: '진행중'},
    2: {name: '심사중'},
    3: {name: '발표완료'},
};
const categoryType = {
    2: {name: '아트'},
    178: {name: '프롬프트'},
    9: {name: '수집품'},
    3: {name: '사진'},
    5: {name: '음악'},
    4: {name: '동영상'},
};




export {competitionStatus,categoryType};
